
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2024-09-08-gsap-svg-transform-origin",
      function () {
        return require("private-next-pages/blogs/2024-09-08-gsap-svg-transform-origin/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2024-09-08-gsap-svg-transform-origin"])
      });
    }
  